/**
 * Description: axios配置
 */
import axios from 'axios';
import Vue from 'vue';
import { Message } from 'element-ui';
import router from '../router';
import { RETURN_CODE, CODE_SUCCESS, BUSINESS_CODE, CODE_OCCUPIED } from './code';

axios.defaults.withCredentials = true; // 需要凭证
axios.defaults.timeout = 60000;

var CancelToken = axios.CancelToken;
var source = CancelToken.source();
// 正在进行中的请求列表
let reqList = [];

/**
 * 阻止重复请求
 * @param {array} reqList - 请求缓存列表
 * @param {string} url - 当前请求地址
 * @param {function} cancel - 请求中断函数
 * @param {string} errorMessage - 请求中断时需要显示的错误信息
 */
const stopRepeatRequest = function (reqList, url, data, method, cancel, errorMessage) {
    const errorMsg = errorMessage || '';
    let pendingUrl = {
        url,
        data,
        method
    };
    for (let i = 0; i < reqList.length; i++) {
        let isRequest = equalsObj(reqList[i].data, data);
        // 判断请求地址是否一致，请求方法是否一致，请求参数是否一致
        if (reqList[i].url == url && reqList[i].method == method && isRequest &&
            reqList[i].url != '/api/evaluation/getEcaluationModel' &&
            reqList[i].url != '/api/exam/evalExam/examListPageByArticipantId' &&
            reqList[i].url != '/api/project/project/projectCardListNew') {
                cancel(errorMsg);
                return;
            }
    }
    // 正在进行中的接口
    reqList.push(pendingUrl);
};
/**
 * 允许某个请求可以继续进行
 * @param {array} reqList 全部请求列表
 * @param {string} url 请求地址
 */
const allowRequest = function (reqList, url) {
    for (let i = 0; i < reqList.length; i++) {
        if (reqList[i].url === url) {
            reqList.splice(i, 1);
            break;
        }
    }
};
// 请求拦截
axios.interceptors.request.use(
    config => {
        let { url } = config;
        url = url.split('?');
        let token = JSON.parse(window.sessionStorage.getItem('access_token'));
        // 没有登陆且不是登陆，阻断所有请求
        if (!token) {
            config.cancelToken = source.token;
            source.cancel('user dont login');
            // router.push({ name: 'Login', path: '/Login' }) // 这个地方注释了
        }
        if (token) {
            // 让每个请求携带自定义token
            // 如果为主站登录请求  不带此参数
            if (url[0] != '/api/auth/frontmodule/authRegisterUser/token-exist' && url[0] != '/api/auth/product/packages') {
                config.headers['Authorization'] = 'Bearer ' + token;
            }
        }
        let cancel;
        // 设置cancelToken对象
        config.cancelToken = new axios.CancelToken(function (c) {
            cancel = c;
        });
        stopRepeatRequest(reqList, config.url, config.data, config.method, cancel, `${config.url} 请求被中断`);
        return config;
    }, error => {
        return Promise.reject(error);
    }
);
/**
 * 判断此对象是否是Object类型
 * @param {Object} obj
 */
function isObject (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
};
/**
 * 判断此类型是否是Array类型
 * @param {Array} arr
 */
function isArray (arr) {
    return Object.prototype.toString.call(arr) === '[object Array]';
};
/**
 *  深度比较两个对象是否相同
 * @param {Object} oldData
 * @param {Object} newData
 */
function equalsObj (oldData, newData) {
    // 类型为基本类型时,如果相同,则返回true
    if (!oldData || !newData) return false;
    if (oldData === newData) return true;
    if (isObject(oldData) && isObject(newData) && Object.keys(oldData).length === Object.keys(newData).length) {
        //      类型为对象并且元素个数相同
        //      遍历所有对象中所有属性,判断元素是否相同
        for (const key in oldData) {
            if (oldData.hasOwnProperty(key)) {
                if (!equalsObj(oldData[key], newData[key])) { // 对象中具有不相同属性 返回false
                    return false;
                }
            }
        }
    } else if (isArray(oldData) && isArray(oldData) && oldData.length === newData.length) {
        // 类型为数组并且数组长度相同
        for (let i = 0, length = oldData.length; i < length; i++) {
            if (!equalsObj(oldData[i], newData[i])) { return false; }
            // 如果数组元素中具有不相同元素,返回false
        }
    } else {
        // 其它类型,均返回false
        return false;
    }
    // 走到这里,说明数组或者对象中所有元素都相同,返回true
    return true;
};

let tipCode = false;
// http response 响应拦截器
axios.interceptors.response.use(
    response => {
        tipCode = false;
        setTimeout(() => {
            allowRequest(reqList, response.config.url);
        }, 300);
        if (response.config.url.indexOf('/auth/oauth/token') != -1) {
            tipCode = false;
            return response.data;
        }
        if (response.headers['content-disposition']) {
            var downLoadMark = response.headers['content-disposition'].split(';');
            if (downLoadMark[0] === 'attachment') {
                // 执行下载
                let fileName = downLoadMark[1].split('filename=')[1];
                // if (response.data.size > 0 && fileName) {
                if (fileName) {
                    fileName = decodeURI(fileName);
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(new Blob([response.data]), fileName);
                    } else {
                        let url = window.URL.createObjectURL(new Blob([response.data]));
                        let link = document.createElement('a');
                        link.style.display = 'none';
                        link.href = url;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                        return;
                    }
                } else {
                    return response.data;
                }
            }
        }
        // var downLoadMark = response.headers.split(';')
        // ------------------------------------------------------------------------------------------
        // removePending(res.config);  //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
        // -------------------------------------------------------------------------------------------
        if (response.data.code !== CODE_SUCCESS) {
            // 如果不存在code.code == response.data.code,返回undefined
            // Message.warning({
            //     message: response.data.msg
            // });
            if (CODE_OCCUPIED.includes(response.data.code)) {
                router.replace({
                    path: '/'
                });
            }
            return Promise.reject(response.data);
        }
        RETURN_CODE.map(function (cur) {
            if (response.data.code === cur.code && response.data.code !== CODE_SUCCESS) {
                if (response.data.code === 500) {
                    // Message.error({
                    //     message: response.data.msg
                    // });
                } else {
                    // Message.warning({
                    //     message: response.code === 100 ? response.data.data : response.data.msg
                    // });
                }
            }
        });
        return response.data;
    }, error => {
        // 防重复提交
        if (error.config) {
            allowRequest(reqList, error.config.url);
        }
        if (error.response) {
            if (error.response.data.code == 600 && !tipCode) {
                tipCode = true;
                // Message.error({ message: '系统登录身份令牌失效，请重新登录！' });
                // Vue.prototype.$tokenError.methods.show(error.response.data.msg)
                let vuex = JSON.parse(window.sessionStorage.getItem('vuex'));
                if (vuex.userInfo.userFlag) {
                    router.push({ name: 'back-login', path: '/back-login' });
                } else {
                    router.push({ path: '/' });
                }
            } else if (error.response.status == 500) {
                // Message.error({ message: '系统异常' });
            }
        }
        return Promise.reject(error);
    }
);

// get
export async function fetchGet (url, params = {}, config = {}) {
    // eslint-disable-next-line no-return-await
    let configuration = {};
    if (params) {
        configuration.params = params;
    }
    if (config) {
        Object.assign(configuration, config);
    }
    return await axios.get(url, configuration);
}

// post
export async function fetchPost (url, data = {}) {
    // eslint-disable-next-line no-return-await
    return await axios.post(url, data);
}

// post下载方法
export async function fetchDownLoad (url, data = {}) {
    // eslint-disable-next-line no-return-await
    return await axios.post(url, data, { responseType: 'blob' });
}

// get下载
export async function fetchGetDownLoad (url, params = {}) {
    // eslint-disable-next-line no-return-await
    return await axios.get(url, {
        params: params,
        responseType: 'blob'
    });
}

// put
export async function fetchPut (url, data = {}) {
    // eslint-disable-next-line no-return-await
    return await axios.put(url, data);
}

// delete
export async function fetchDel (url, data = { emulateJSON: true }) {
    // eslint-disable-next-line no-return-await
    return await axios.delete(url, data);
}
// userFlag = 0; // 前台用户0，后台用户1
export const userFlag = JSON.parse(window.sessionStorage.getItem('setUserInfo')) ? JSON.parse(window.sessionStorage.getItem('setUserInfo')).userFlag : '';



// WEBPACK FOOTER //
// ./src/axios/index.js